import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import Error from '@/components/Error';

import './style.less';

interface ILoading {
  visibility?: boolean,
  error?: boolean,
  errorText?: string
  routerPushHome?: any
}

@Component
export default class Loading  extends tsx.Component<ILoading> {

  @Prop() public visibility?: boolean
  @Prop() public error?: boolean
  @Prop() public errorText?: string
  @Prop() public routerPushHome?: any

  render() {
    return this.$props.visibility ? (
      <div class='loading-container'>
        {this.$props.error ?
          <Error click={this.$props.routerPushHome} text={this.$props.errorText} /> :
          <img class='img' src={require('@/assets/gif/LOADING.gif')} />
        }
      </div>
    ) : null
  }

}
